<template>
  <a-form class="root">
    <h3>Присоединиться к команде</h3>

    <a-form-item name="lastName">
      <a-input :value="request.lastName" placeholder="Ваша фамилия" disabled />
    </a-form-item>

    <a-form-item name="firstName">
      <a-input :value="request.firstName" placeholder="Ваше имя" disabled />
    </a-form-item>

    <a-form-item name="middleName">
      <a-input
        :value="request.middleName"
        placeholder="Ваше отчество"
        disabled
      />
    </a-form-item>

    <a-form-item name="email">
      <a-input :value="request.email" placeholder="E-mail" disabled />
    </a-form-item>

    <a-form-item name="courseNumber">
      <a-input :value="request.courseNumber" placeholder="Номер курса" disabled />
    </a-form-item>

    <a-form-item name="faculty">
      <a-input :value="request.faculty" placeholder="Факультет" disabled />
    </a-form-item>

    <a-form-item name="phone">
      <a-input :value="request.phone" placeholder="Номер телефона" disabled />
    </a-form-item>

    <a-form-item name="coverLetter">
      <a-textarea
        :value="request.coverLetter"
        placeholder="Расскажите ту информацию о себе, которая, на ваш взгляд, будет полезна для руководителя проекта и будет способствовать приглашению Вас в команду."
        :autoSize="{ minRows: 9, maxRows: 9 }"
        disabled
      />
    </a-form-item>

    <div class="buttons">
      <c-button-danger @click="handleReject()">
        Отказать
      </c-button-danger>
      <button-primary @click="handleAccept()">
        Принять в команду
      </button-primary>
    </div>
  </a-form>
</template>

<script setup>
  import { ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import ButtonPrimary from '@/views/portal/components/UI/ButtonPrimary.vue';
  import CButtonDanger from '@/components/UI/CButtonDanger.vue';

  const isLoading = ref(false);

  const props = defineProps({
    request: Object,
  });

  const api = useApi();
  const emit = defineEmits(['close', 'change-request']);

  const handleReject = async () => {
    try {
      isLoading.value = true;
      await api.projectTeamRequest.reject(props.request.id);
      emit('change-request');
      emit('close');
    } catch (error) {
      console.error(error);
    } finally {
      isLoading.value = false;
    }
  };

  const handleAccept = async () => {
    try {
      isLoading.value = true;
      await api.projectTeamRequest.approve(props.request.id);
      emit('change-request');
      emit('close');
    } catch (error) {
      console.error(error);
    } finally {
      isLoading.value = false;
    }
  };
</script>

<style scoped lang="scss">
  @use "@/assets/styles/_colors.scss" as *;

  .root {
    padding-inline: 16px;

    h3 {
      margin-top: 110px;
    }

    .buttons {
      display: flex;
      justify-content: space-between;
      gap: 23px;
      margin-top: 26px;
    }

    :deep(.ant-form-item) {
      margin-bottom: 14px;

      .ant-input {
        border-color: $color-input;
        color: $color-tag;
      }
    }
  }
</style>
